const startCalling = (apiTitle: string) => ({
  type: 'START_CALLING',
  apiTitle
});

const finishCalling = (apiTitle: string) => ({
  type: 'FINISH_CALLING',
  apiTitle
});

const failCalling = (apiTitle: string, errorMessage: string) => ({
  type: 'FAIL_CALLING',
  apiTitle,
  errorMessage
});

const serverErrorCalling = () => ({
  type: 'SERVER_ERROR_CALLING'
});

const noInternetCalling = () => ({
  type: 'NO_INTERNET_CALLING'
});

const errorCalling = () => ({
  type: 'ERROR_CALLING'
});

const clearErrorMessage = () => ({
  type: 'CLEAR_ERROR_MESSAGE'
});

export {
  startCalling,
  finishCalling,
  failCalling,
  errorCalling,
  serverErrorCalling,
  noInternetCalling,
  clearErrorMessage
};



// WEBPACK FOOTER //
// ./src/actions/network.ts